"use client";
import { ArrowCornerCwLb, ArrowRightCircle } from "@layer/icons";
import { Button } from "@layer/ui/components";
import { startTransition, useActionState, useEffect, useState } from "react";

import MPLogo from "@/assets/logos/mp-logo";
import { authenticateUser } from "./action";

const SignInPage = () => {
	const [animateLogo, setAnimateLogo] = useState(false);
	const [errorMessage, formAction, isPending] = useActionState(
		authenticateUser,
		undefined,
	);

	useEffect(() => {
		const handleKeyPress = (e: KeyboardEvent) => {
			if (e.key === "Enter") {
				startTransition(() => {
					formAction();
				});
			}
		};

		window.addEventListener("keydown", handleKeyPress);
		return () => window.removeEventListener("keydown", handleKeyPress);
	}, [formAction]);

	return (
		<form
			className="flex w-72 flex-col items-center space-y-4 py-10 sm:px-8"
			action={formAction}
		>
			<header className="pb-2 text-center">
				<MPLogo
					animateLogo={animateLogo}
					className="mx-auto block h-14"
				/>
				<h1 className="text-neutral-text-contrast mt-4 font-mono text-base tracking-widest">
					Deployment Tracker
				</h1>
			</header>
			<div className="relative flex w-48 flex-col items-center gap-y-1">
				<Button
					onMouseEnter={() => setAnimateLogo(true)}
					onMouseLeave={() => setAnimateLogo(false)}
					loading={isPending}
					disabled={isPending}
					type="submit"
					variant="default"
					className="mx-auto w-48"
				>
					<ArrowRightCircle
						variant="filled"
						className="mx-auto h-full w-full"
					/>
				</Button>

				<span className="text-neutral-text inline-block self-end text-sm">
					or press{" "}
					<ArrowCornerCwLb variant="gestalt" className="inline" />
				</span>
			</div>
			<div className="-pt-2 text-danger-text text-sm">
				<span>{errorMessage}</span>
			</div>
		</form>
	);
};

export default SignInPage;
